import { CSSObject } from '@chakra-ui/react';

export const ContainerForms: CSSObject = {
  mt: '1',
  maxW: ['none', 'lg'],
  '.chakra-checkbox__control': {
    bg: 'white',
    border: '0',
    boxShadow: 'inset 0 2px 4px rgba(49, 57, 77, .82)',
    _focus: {
      boxShadow: 'inset 0 2px 4px rgba(49, 57, 77, .82)',
    },
    _disabled: {
      opacity: '0.4',
    },
    _invalid: {
      bg: 'red.100',
    },
    _checked: {
      bg: 'alpha.400',
      boxShadow: 'none',
      _hover: {
        bg: 'alpha.400',
      },
      _focus: {
        boxShadow: 'none',
      },
      _invalid: {
        bg: 'alpha.400',
      },
    },
  },
  '.chakra-radio__input + span': {
    bg: 'gray.200',
    border: '0',
    width: '1rem',
    height: '1rem',
  },
  '.chakra-radio': {
    _checked: {
      '.chakra-radio__input + span': {
        bg: 'gray.200',
        border: '2px',
        borderColor: 'gray.200',
        color: 'beta.500',
        boxShadow: 'none',
      },
    },
  },
  '.chakra-form__label': {
    color: 'white',
  },
  '&& .chakra-input__left-addon': {
    bg: 'alpha.300',
    borderLeftRadius: 'base',
    color: 'alpha.800',
    fontWeight: 'semibold',
    fontSize: 'sm',
    h: '9',
  },
  '.chakra-input': {
    border: '1px',
    borderColor: 'gray.300',
    bg: 'white',
    h: '9',
    fontWeight: 'semibold',
    borderLeft: 'none',
    _hover: {
      bg: 'gray.50',
    },
    _active: {
      bg: 'gray.100',
    },
  },
  '.chakra-input__group .chakra-input': {
    borderRightRadius: 'base',
    fontSize: 'sm',
  },
  '.chakra-select': {
    border: '1px',
    borderColor: 'gray.400',
    bg: 'gray.50',
    h: '9',
  },
  '.chakra-form__error-message': {
    color: '#fff',
    fontSize: 'xs',
    mb: 2,
  },
  '.chakra-form__helper-text': {
    color: '#fff',
    fontSize: 'xs',
  },
};
